// extracted by mini-css-extract-plugin
export default {"priorityButton":"DefinePriorities_priorityButton__xfR8-","container":"DefinePriorities_container__cHbpo","noSitesSvg":"DefinePriorities_noSitesSvg__WUMex"};